/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrderCommand } from '../../models/delete-order-command';
import { DeleteOrderCommandResult } from '../../models/delete-order-command-result';

export interface ApiNurseryManagerOrdersDeleteOrderDelete$Params {
      body?: DeleteOrderCommand
}

export function apiNurseryManagerOrdersDeleteOrderDelete(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersDeleteOrderDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersDeleteOrderDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOrderCommandResult>;
    })
  );
}

apiNurseryManagerOrdersDeleteOrderDelete.PATH = '/api/NurseryManager/Orders/DeleteOrder';
